import { css } from 'styled-components';

export const BtnMixin = css`
  display: block;
  margin-bottom: 10px;

  .panda-typography--P1 {
    font-size: 14px;
  }
`;
